import { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { Box, Divider, Paper } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import ArrowBackButton from '../../../Base/views/ArrowBackButton';
import Prompt from './Prompt';
import General from './General';
import Preview from './Preview';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#8b44ff',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#8b44ff',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[500] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
        color: '#8b44ff',
    }),
    '& .QontoStepIcon-completedIcon': {
        color: '#8b44ff',
        zIndex: 1,
        fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
}));

function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                <div className="QontoStepIcon-circle" />
            )}
        </QontoStepIconRoot>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
};


const defaultSteps = [
    'Prompt Customization',
    'Offer Letter Customization',
    'CTC Detail Configuration',
    'Preview',
];

const OfferLetterForm = (props) => {
    const { setCurrentMode, currentMode, data, setData, companylogo, letterHeadData } = props
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const [isStepLoading, setIsStepLoading] = useState(false);

    const isConfigureCtc = data?.is_configure_ctc !== false;
    const steps = isConfigureCtc
        ? defaultSteps
        : ['Prompt Customization', 'Offer Letter Customization', 'Preview'];

    function getStepContent(stepIndex) {
        if (!isConfigureCtc) {
            switch (stepIndex) {
                case 0:
                    return (
                        <Prompt
                            setCurrentMode={setCurrentMode}
                            currentMode={currentMode}
                            setActiveStep={setActiveStep}
                            activeStep={activeStep}
                            data={data}
                            setData={setData}
                            companylogo={companylogo}
                            letterHeadData={letterHeadData}
                            isStepLoading={isStepLoading}
                            setIsStepLoading={setIsStepLoading}
                        />
                    );
                case 1:
                    return (
                        <General
                            setCurrentMode={setCurrentMode}
                            currentMode={currentMode}
                            setActiveStep={setActiveStep}
                            activeStep={activeStep}
                            data={data}
                            setData={setData}
                            companylogo={companylogo}
                            letterHeadData={letterHeadData}
                            editorSubStep="general"
                            isStepLoading={isStepLoading}
                            setIsStepLoading={setIsStepLoading}
                        />
                    );
                case 2:
                    return (
                        <Preview
                            setCurrentMode={setCurrentMode}
                            currentMode={currentMode}
                            setActiveStep={setActiveStep}
                            activeStep={activeStep}
                            data={data}
                            setData={setData}
                            companylogo={companylogo}
                            letterHeadData={letterHeadData}
                            isStepLoading={isStepLoading}
                            setIsStepLoading={setIsStepLoading}
                        />
                    );
                default:
                    return "Unknown stepIndex";
            }
        }

        switch (stepIndex) {
            case 0:
                return (
                    <Prompt
                        setCurrentMode={setCurrentMode}
                        currentMode={currentMode}
                        setActiveStep={setActiveStep}
                        activeStep={activeStep}
                        data={data}
                        setData={setData}
                        companylogo={companylogo}
                        letterHeadData={letterHeadData}
                        isStepLoading={isStepLoading}
                        setIsStepLoading={setIsStepLoading}
                    />
                );
            case 1:
                return (
                    <General
                        setCurrentMode={setCurrentMode}
                        currentMode={currentMode}
                        setActiveStep={setActiveStep}
                        activeStep={activeStep}
                        data={data}
                        setData={setData}
                        companylogo={companylogo}
                        letterHeadData={letterHeadData}
                        editorSubStep="general"
                        isStepLoading={isStepLoading}
                        setIsStepLoading={setIsStepLoading}
                    />
                );
            case 2:
                return (
                    <General
                        setCurrentMode={setCurrentMode}
                        currentMode={currentMode}
                        setActiveStep={setActiveStep}
                        activeStep={activeStep}
                        data={data}
                        setData={setData}
                        companylogo={companylogo}
                        letterHeadData={letterHeadData}
                        editorSubStep="ctc"
                        isStepLoading={isStepLoading}
                        setIsStepLoading={setIsStepLoading}
                    />
                );
            case 3:
                return (
                    <Preview
                        setCurrentMode={setCurrentMode}
                        currentMode={currentMode}
                        setActiveStep={setActiveStep}
                        activeStep={activeStep}
                        data={data}
                        setData={setData}
                        companylogo={companylogo}
                        letterHeadData={letterHeadData}
                        isStepLoading={isStepLoading}
                        setIsStepLoading={setIsStepLoading}
                    />
                );
            default:
                return "Unknown stepIndex";
        }
    }


    return (


        <Paper sx={{ ".MuiDrawer-paper": { backgroundColor: `${theme.palette.mode === "dark" ? "#544166" : "white"}` }, borderRadius: "10px", padding: "4px 6px 0px 6px" }}>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ display: "flex", alignItems: "center", width: "100%", pt: 0.5, px: 0.5 }}>
                    <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
                        <ArrowBackButton onClick={() => setCurrentMode("grid")} iconSize={18} />
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
                            {steps.map((label, index) => (
                                <Step key={label} onClick={() => !isStepLoading && setActiveStep(index)} sx={{ cursor: isStepLoading ? "not-allowed" : "pointer" }}>
                                    <StepLabel StepIconComponent={QontoStepIcon}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Box>
                </Box>
                <Divider variant="middle" flexItem sx={{ paddingTop: "2px", paddingBottom: "2px" }} />

                <div style={{ padding: "4px 0px 0px 0px" }}>
                    {getStepContent(activeStep)}
                </div>
            </Box>
        </Paper >

    );
}

export default OfferLetterForm;
